var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex h-8 border-b border-blue-10"},[_vm._l((_vm.emptyDaysStart),function(n){return _c('TimetableCell',{key:'empty-start' + n})}),_vm._l((_vm.month.days),function(day,$i){return _c('TimetableCell',{key:$i,attrs:{"day":day}})}),_vm._l((_vm.emptyDaysEnd),function(n){return _c('TimetableCell',{key:'empty-end' + n})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }